// extracted by mini-css-extract-plugin
export default {"cell":"OrderRow_cell__+M2qv","fontSize":"OrderRow_fontSize__cK6pd"};